

'use strict';

angular.module('pulianiBookStoreApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('shippingDelivery', {
        url: '/shippingDelivery',
        templateUrl: 'app/shipping_delivery/shipping_delivery.html',
        controller: 'ShippingDeliveryCtrl'
      });
  });
